var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination__button",attrs:{"id":"load-more"}},[_c('button',{staticClass:"button button--lg button--yellow button--rounded"},[_c('span',{staticClass:"text-small"},[_vm._v("Showing "+_vm._s(_vm.assetsShown)+" of "+_vm._s(_vm.totalAssetsCount))]),_c('span',[_vm._v("LOAD MORE")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }